export const INCREASE_AREA_THRESHOLD_PERCENTAGE = 2;
export const DECREASE_AREA_THRESHOLD_PERCENTAGE = -3;
